// Mount the Settings routes. Settings hosts pages that belong to other
// modules (the SLA templates are Service's, Authorization is its own module)
// under /settings/*; it does not import them. This composition root hands them
// in, in the slots where they sat in the route list, so URLs and route order
// are unchanged (#253). App.tsx mounts the route from HERE.
import { createSettingsModule } from '@/modules/Settings'
import { SLASettingsRoutes } from '@/modules/Service'
import AuthorizationRoutes from '@/modules/Authorization'

export const SettingsRoute = createSettingsModule({
    slaTemplates: SLASettingsRoutes,
    authorization: AuthorizationRoutes,
})
